import { useState, useEffect } from 'react';
import { MasonryPhotoAlbum } from 'react-photo-album';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';

// https://react-photo-album.com/examples/masonry
import 'react-photo-album/masonry.css';

import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

export default function Galeria({ galerias }) {
  const [photosByGroup, setPhotosByGroup] = useState({});
  const [lightboxGroup, setLightboxGroup] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  useEffect(() => {
    async function load() {
      const processed = {};

      for (const grupo of galerias) {
        processed[grupo.titulo] = await Promise.all(
          grupo.imagens.map((src) => {
            return new Promise((resolve) => {
              const img = new Image();
              img.src = src;
              img.onload = () =>
                resolve({
                  src,
                  width: img.naturalWidth,
                  height: img.naturalHeight,
                });
            });
          }),
        );
      }

      setPhotosByGroup(processed);
    }

    load();
  }, [galerias]);

  return (
    <div style={{ marginTop: '50px' }}>
      {Object.keys(photosByGroup).length === 0 && <p>Carregando...</p>}

      {Object.entries(photosByGroup).map(([titulo, fotos]) => (
        <div key={titulo} className="mb-5">
          <h4 className="mb-3">{titulo}</h4>

          <MasonryPhotoAlbum
            layout="masonry"
            photos={fotos}
            targetRowHeight={250}
            onClick={({ index }) => {
              setLightboxGroup(titulo);
              setLightboxIndex(index);
            }}
          />

          {lightboxGroup === titulo && (
            <Lightbox
              open={lightboxIndex >= 0}
              index={lightboxIndex}
              close={() => setLightboxIndex(-1)}
              slides={fotos}
              plugins={[Thumbnails]}
            />
          )}
        </div>
      ))}
    </div>
  );
}
